namespace Nobox {
    export interface ListChannel {
        Id?: number;
        Nm?: string;
    }
}
